import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import _ from 'lodash';

import Header from '../components/Header';
import Footer from '../components/Footer';
import AuthorPosts from './AuthorPosts';

class SingleAuthor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
        };
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        axios
            .get('https://friendsagency.com/wp-json/wp/v2/users')
            .then((response) => {
                const data = response.data;
                const slug = this.props.match.params.slug;
                const index = _.findIndex(data, ['slug', slug]);
                if (index !== -1) {
                    const authorId = response.data[index].id;
                    this.setState({
                        id: authorId,
                    });
                    document.title = `${response.data[index].name} - Friends for Brands`;
                } else {
                    this.setState({
                        id: 'none',
                    });
                }
            });
    }

    getAuthorPosts() {
        if (this.state.id !== null) {
            if (this.state.id !== 'none') {
                return <AuthorPosts id={this.state.id} />;
            } else {
                return (
                    <h2 className="fadeIn">:(! Deze gebruiker bestaat niet</h2>
                );
            }
        }
    }

    render() {
        return (
            <div className="single author">
                <Header />
                <main>
                    <div id="main-container">
                        <div className="content-container">
                            <header className="intro-header">
                                <div className="two-col">
                                    <h1>{this.props.match.params.slug}</h1>
                                </div>
                            </header>
                            <div className="clearfix" />
                            {this.getAuthorPosts()}
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        );
    }
}

export default withRouter(SingleAuthor);



// WEBPACK FOOTER //
// ./src/containers/SingleAuthor.jsx